import { render, staticRenderFns } from "./FormularioPesaje.vue?vue&type=template&id=6d6a1ae6"
import script from "./FormularioPesaje.vue?vue&type=script&lang=ts"
export * from "./FormularioPesaje.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports